import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    document.title = 'Basetao Spreadsheet - Complete Database, Reviews, Shipping Guide & Shopping Resources';
  }, []);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Basetao Spreadsheet Resource Hub',
    description: 'Discover the ultimate Basetao Spreadsheet resource. Explore product databases, reviews, shipping costs, coupons, warehouse guides, discount codes and expert buying tutorials.',
    url: 'https://basetaosheet.cyou/',
    mainEntity: {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Is Basetao Spreadsheet free?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Access to the Basetao Spreadsheet depends on the provider. Some versions are freely shared within community groups, while premium curated versions may require a purchase.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is Basetao legit?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, Basetao is a legitimate and well-established shopping agent platform serving international customers for many years.',
          },
        },
        {
          '@type': 'Question',
          name: 'How much is Basetao shipping?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Basetao shipping costs vary based on package weight, dimensions, shipping method, and destination country. Express shipping costs more but is faster, while economy options are more affordable.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I use Basetao Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Obtain access to the spreadsheet, open it in Google Sheets or Excel, browse organized categories, and use product links to place orders on the Basetao platform.',
          },
        },
      ],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ContentSections />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}